export default __webpack_public_path__ + "static/media/grafema_ss-wedding-identity_02.38f6d035.jpg";